module.exports = __webpack_public_path__ + "img/STEEM-alt.f4e61bb4.svg";